export const SCROLL_DIRECTION = {
  Vertical: 'vertical',
  Horizontal: 'horizontal',
} as const;

export const CROSS_AXIS_OVERFLOW = {
  Hidden: 'hidden',
  Visible: 'visible',
  Auto: 'auto',
} as const;

export const CSCROLLABLE_ROOT_CLASS_NAME = 'cscrollable-root';
/**
 * Default cross-axis bleed gutter (px). 0 preserves the historical clip-tight
 * behavior for every consumer that does not opt in. Consumers whose children
 * hover-scale / morph past the scroll box (e.g. show6 card carousels) pass a
 * positive value to push the overflow clip boundary off the visible card region.
 */
export const CSCROLLABLE_DEFAULT_CROSS_AXIS_BLEED_PX = 0;
export const CSCROLLABLE_WILL_CHANGE_SCROLL_POSITION = 'scroll-position';
export const CSCROLLABLE_CONTAIN_LAYOUT = 'layout';
export const CSCROLLABLE_SEQ_COMPONENT = 'Cscrollable';
export const CSCROLLABLE_SCROLL_PROGRESS_BUCKETS = 20;
export const CSCROLLABLE_DEBUG_HIERARCHY_DEPTH = 10;
export const SESSIONS_LIST_SCROLL_FADE_FEATURE = 'sessions-list-scroll-fade';
export const CSCROLLABLE_MASK_IMAGE_PROPERTY = 'mask-image';
export const CSCROLLABLE_WEBKIT_MASK_IMAGE_PROPERTY = '-webkit-mask-image';
/**
 * Scrollport height (padding box, i.e. `clientHeight`) published as a custom
 * property on the scroll element so descendants can anchor viewport-relative
 * geometry in pure CSS. Written on mount and on resize only — never per scroll.
 */
export const CSCROLLABLE_VIEWPORT_BLOCK_SIZE_PROPERTY =
  '--cscrollable-viewport-block-size';
export const CSS_MASK_NONE = 'none';
export const CSCROLLABLE_PADDING_MATCH_TOLERANCE_PX = 1;

export enum CscrollableDebugReason {
  ChildrenChanged = 'children-changed',
  FadeStateChanged = 'fade-state-changed',
  InitialMount = 'initial-mount',
  ResizeObserved = 'resize-observed',
  ScrollSample = 'scroll-sample',
}

export enum CscrollableFadeZonePosition {
  AboveFade = 'aboveFade',
  BelowVisible = 'belowVisible',
  InFadeZone = 'inFadeZone',
}
